interface CustomPaginationHeaderProps {
    totalCount: number;
    pageSize: number;
    currentPage: number;
}

const CustomPaginationHeader = ({ totalCount, pageSize, currentPage }: CustomPaginationHeaderProps) => (
    <span hidden={totalCount <= 0}>
        {'Displaying '}
        <strong>
            {(currentPage - 1) * pageSize + 1}
            {' - '}
            {currentPage * pageSize
                                > totalCount ? totalCount
                : currentPage * pageSize}
        </strong>
        {' of '}
        <strong>{totalCount}</strong>
        <span className='visually-hidden'>{' Results'}</span>
    </span>
);

export default CustomPaginationHeader;
